<!-- =========================================================================================
  File Name: UserList.vue
  Description: Module Fields List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-user-list">
    <vs-alert icon="warning" active="true" color="warning" class="my-5" v-show="unsavedLayout">
      <span>Atenção! Você possui alterações de layout não salvas.</span>
    </vs-alert>
    <vs-popup id="edit-block" title="Editar Bloco" :active.sync="onChangeEditBlockPopUp">
      <div class="vx-row" id="edit-block">
        <div class="vx-col md:w-1/2 w-full mt-2 mb-3">
          <vs-input label="Nome do Bloco" v-model="blockEditDataObject.title" class="w-full" type="text" name="block-title-edit"/>
        </div>
        <ul class="switch-container mt-2 ml-3">
          <li>
            <label class="vs-input--label">Colapsado</label>
            <vs-switch v-model="blockEditDataObject.collapsed" class="mt-1 ml-1" />
          </li>
        </ul>
        <ul class="switch-container mt-2 ml-3">
          <li>
            <label class="vs-input--label">Visível</label>
            <vs-switch v-model="blockEditDataObject.visible" class="mt-1 ml-1" />
          </li>
        </ul>
      </div>
      <div class="vx-row mt-2">
        <div class="vx-col w-full">
          <label class="vs-input--label">Exibir bloco para as roles (deixe vazio para todas)</label>
          <v-select multiple v-model="blockEditDataObject.roles" :options="roleList" label="name" :reduce="r => r.hash" :closeOnSelect="false" placeholder="Selecione as roles..." name="block-roles-edit" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
      </div>
    </vs-popup>
    <vs-popup id="add-field" title="Adicionar Campo" :active.sync="addFieldPopUpActive">
      <form-wizard color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null" finishButtonText="Submit" @on-complete="addFormSubmitted">
          <tab-content title="Dados Básicos" class="mb-5" :before-change="validateStep1Add">

              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full">
                  <label class="vs-input--label">Tipo</label>
                  <v-select v-model="fieldData.type" class="field-type-select" :clearable="false" :options="fieldData.typeOptions" label="name" name="columnsOnForm" @input="onFieldTypeChange" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <label class="vs-input--label">Colunas no formulário</label>
                  <v-select v-model="fieldData.columnsOnForm" :clearable="false" :options="fieldData.columnsOnFormOptions" name="columnsOnForm" :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="fieldData.disableAll"/>
                </div>
              </div>

              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full mt-5">
                  <vs-input label="Nome" v-model="fieldData.name" class="w-full" :disabled="fieldData.disableAll"/>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5">
                  <vs-input label="Legenda"  v-model="fieldData.subtitle" class="w-full" :disabled="fieldData.disableAll"/>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5">
                  <ul class="switch-container">
                    <li>
                      <label class="vs-input--label">Mostrar Dica</label>
                      <vs-switch v-model="fieldData.showHint" class="mt-1 ml-1" :disabled="fieldData.disableAll"/>
                    </li>
                  </ul>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5">
                  <vs-input type="email" label="Dica"  v-model="fieldData.hint" v-show="fieldData.showHint" class="w-full" :disabled="fieldData.disableAll"/>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full mt-5"></div>
              </div>
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full mt-5"></div>
              </div>
          </tab-content>

          <tab-content title="Geral" class="mb-5" :before-change="validateStep2Add">
              <div class="vx-row" v-if="fieldData.type.id === 25">
                <div class="vx-col md:w-1/2 w-full">
                  <label class="vs-input--label">Relacionado ao módulo</label>
                  <v-select v-model="fieldData.relatedModule" class="field-type-select" :clearable="false" :options="fieldData.moduleOptions" @input="onRelatedModuleChange" label="name" name="related-module" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <label class="vs-input--label">Relacionado ao campo</label>
                  <v-select v-model="fieldData.relatedField" class="field-type-select" :clearable="false" :options="fieldData.moduleFieldOptions" label="name" name="related-module-field" @input="$event.id > 0 ? fieldData.disableAll = false : fieldData.disableAll = true" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                </div>
                <div class="vx-col mt-2 md:w-1/2 w-full">
                  <label class="vs-input--label">Depende do campo</label>
                  <v-select v-model="fieldData.dependentField" class="field-type-select" :clearable="true" :options="fieldData.relatedFieldOptions" label="name" name="related-module-field" :disabled="fieldData.dependentDisable" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                </div>
              </div>
              <div class="vx-row" v-if="fieldData.type.id == 24">
                <div class="vx-col md:w-1/2 w-full">
                  <h6 class="mt-5 mb-3">Inserir Item</h6>
                  <vx-input-group class="mb-base mt-5">
                    <vs-input v-model="optionValue" maxlength="100" @keypress.enter="addOptionAddForm"/>
                    <template slot="append">
                      <div class="append-text btn-addon">
                        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus" @click="addOptionAddForm"></vs-button>
                      </div>
                    </template>
                  </vx-input-group>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <h6 class="mt-5 mb-3">Itens da Lista</h6>
                  <draggable :list="fieldData.options" :group="{name:'tags',  pull:'clone', put:false }" class="p-2 cursor-move">
                    <vs-chip color="primary" style="padding-left: 20px!important; padding-right: 20px!important;font-size: 1.0rem!important; min-width: 70px!important; min-height: 35px!important;" v-for="(listItem, index) in fieldData.options" :key="index">
                      <feather-icon icon="XIcon" svgClasses="h-4 w-4 text-outline" class="mr-3" @click="removeItemAddForm(index)" style="cursor: pointer!important; margin-left: -10px!important;"></feather-icon> {{ listItem }} </vs-chip>
                  </draggable>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full mt-5" v-if="showPlaceholder.includes(fieldData.type.id)">
                  <vs-input type="text" label="Placeholder" v-model="fieldData.placeholder" class="w-full" :disabled="fieldData.disableAll"/>
                </div>
                <div class="vx-col mt-5" v-if="fieldData.type.id === 20 || fieldData.type.id === 18">
                  <label class="vs-input--label"> Casas Decimais </label>
                  <vs-input-number v-model="fieldData.decimals" :disabled="fieldData.disableAll" min="1" max="6"/>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5" v-if="fieldData.type.id === 1 || fieldData.type.id === 2 || fieldData.type.id === 3 || fieldData.type.id === 16 || fieldData.type.id === 19 || fieldData.type.id === 23">
                  <vs-input type="text" v-if="fieldData.type.id === 1 || fieldData.type.id === 2 || fieldData.type.id === 3 || fieldData.type.id === 16 || fieldData.type.id === 19" label="Valor Padrão"  v-model="fieldData.defaultValue" class="w-full" :disabled="fieldData.disableAll"/>
                  <ul class="switch-container" v-else-if="fieldData.type.id === 23">
                    <li>
                      <label class="vs-input--label">Valor Padrão</label>
                      <vs-switch v-model="fieldData.defaultValue" class="mt-1 ml-1"/>
                    </li>
                  </ul>
                </div>
                <!-- Min And Max -->
                  <div class="vx-col md:w-1/2 w-full mt-5" v-show="showMinAndMaxValueInt.includes(fieldData.type.id)">
                    <vs-input type="number" label="Valor Mínimo" v-model="fieldData.minValueInt" class="w-full" :disabled="fieldData.disableAll"/>
                  </div>
                  <div class="vx-col md:w-1/2 w-full mt-5" v-show="showMinAndMaxValueInt.includes(fieldData.type.id)">
                    <vs-input type="number" label="Valor Máximo"  v-model="fieldData.maxValueInt" class="w-full" :disabled="fieldData.disableAll"/>
                  </div>

                  <div class="vx-col md:w-1/2 w-full mt-5" v-show="showMinAndMaxValueDate.includes(fieldData.type.id)">
                    <label class="vs-input--label"> Valor Mínimo </label>
                    <flat-pickr  v-model="fieldData.minValueDate" :config="{ dateFormat: 'd/m/Y' }" class="w-full" name="dob" />
                  </div>
                  <div class="vx-col md:w-1/2 w-full mt-5" v-show="showMinAndMaxValueDate.includes(fieldData.type.id)">
                    <label class="vs-input--label"> Valor Máximo </label>
                    <flat-pickr  v-model="fieldData.maxValueDate" :config="{ dateFormat: 'd/m/Y' }" class="w-full" name="dob" />
                  </div>

                  <div class="vx-col md:w-1/2 w-full mt-5" v-show="showMinAndMaxValueDateTime.includes(fieldData.type.id)">
                    <label class="vs-input--label"> Valor Mínimo </label>
                    <flat-pickr  v-model="fieldData.minValueDateTime" :config="{ dateFormat: 'd/m/Y H:i:S', enableTime: true, enableSeconds: true, time_24hr: true }" class="w-full" name="dob" />
                  </div>
                  <div class="vx-col md:w-1/2 w-full mt-5" v-show="showMinAndMaxValueDateTime.includes(fieldData.type.id)">
                    <label class="vs-input--label"> Valor Máximo </label>
                    <flat-pickr  v-model="fieldData.maxValueDateTime" :config="{ dateFormat: 'd/m/Y H:i:S', enableTime: true, enableSeconds: true, time_24hr: true }" class="w-full" name="dob" />
                  </div>


                <!-- Min And Max -->
                <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldData.type.id === 1">
                  <vs-input type="text" label="Máscara"  v-model="fieldData.mask" class="w-full" :disabled="fieldData.disableAll"/>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5" v-show="showLengthField.includes(fieldData.type.id)">
                  <vs-input type="number" label="Tamanho"  v-model="fieldData.length" class="w-full" :disabled="fieldData.disableAll"/>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5" v-show="(fieldData.type.id >= 4 && fieldData.type.id <= 15) || (fieldData.type.id >= 17 && fieldData.type.id <= 19)"></div>
                <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldData.type.id === 25">
                  <ul class="switch-container">
                    <li>
                      <label class="vs-input--label">Exibir Aba Relacionada</label>
                      <vs-switch v-model="fieldData.relatedTab" class="mt-1 ml-1"/>
                    </li>
                  </ul>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldData.type.id !== 21 && fieldData.type.id !== 22">
                  <ul class="switch-container">
                    <li>
                      <label class="vs-input--label">Criação Rápida</label>
                      <vs-switch v-model="fieldData.quickCreate" class="mt-1 ml-1"/>
                    </li>
                  </ul>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldData.type.id !== 21 && fieldData.type.id !== 22">
                  <ul class="switch-container">
                    <li>
                      <label class="vs-input--label">Edição em Massa</label>
                      <vs-switch v-model="fieldData.massEdit" class="mt-1 ml-1"/>
                    </li>
                  </ul>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldData.type.id >= 3 && fieldData.type.id <= 18 ">
                  <ul class="switch-container">
                    <li>
                      <label class="vs-input--label">Exibir Ícone</label>
                      <vs-switch v-model="fieldData.showIcon" class="mt-1 ml-1"/>
                    </li>
                  </ul>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5">
                  <ul class="switch-container">
                    <li>
                      <label class="vs-input--label">Obrigatório</label>
                      <vs-switch v-model="fieldData.mandatory" class="mt-1 ml-1"/>
                    </li>
                  </ul>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5">
                  <ul class="switch-container">
                    <li>
                      <label class="vs-input--label">Linha inteira</label>
                      <vs-switch v-model="fieldData.entireLine" class="mt-1 ml-1"/>
                    </li>
                  </ul>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldData.type.id !== 21 && fieldData.type.id !== 22">
                  <ul class="switch-container">
                    <li>
                      <label class="vs-input--label">Valor Único</label>
                      <vs-switch v-model="fieldData.unique" class="mt-1 ml-1"/>
                    </li>
                  </ul>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5" v-show="showSecretField.includes(fieldData.type.id)">
                  <ul class="switch-container">
                    <li>
                      <label class="vs-input--label">Secreto</label>
                      <vs-switch v-model="fieldData.secret" class="mt-1 ml-1"/>
                    </li>
                  </ul>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldData.type.id === 16">
                  <ul class="switch-container">
                    <li>
                      <label class="vs-input--label">Exibir Progress Bar</label>
                      <vs-switch v-model="fieldData.showProgressBar" class="mt-1 ml-1"/>
                    </li>
                  </ul>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5"></div>
                <div class="vx-col md:w-1/2 w-full mt-5"></div>
              </div>
          </tab-content>

          <!-- tab 2 content -->
          <tab-content title="Permissões" class="mb-5">
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="flex items-end px-3">
                  <feather-icon svgClasses="w-6 h-6" icon="LockIcon" class="mr-2" />
                  <span class="font-medium text-lg leading-none">Selecione a permissão do campo nos cargos</span>
                </div>
                <div style="float: right;">
                  <div style="float: left; margin-right: 12px;">
                    <div style="float: left; margin-right: 6px;">
                      <feather-icon icon="CircleIcon" :svgClasses="['fill-current h-4 w-4 text-dark']" />
                    </div>
                    <div style="float: left;">
                      <span>Oculto</span>
                    </div>
                  </div>
                  <div style="float: left; margin-right: 12px;">
                    <div style="float: left; margin-right: 6px;">
                      <feather-icon icon="CircleIcon" :svgClasses="['fill-current h-4 w-4 text-primary']" />
                    </div>
                    <div style="float: left;">
                      <span>Somente Leitura</span>
                    </div>
                  </div>
                  <div style="float: left; margin-right: 12px;">
                    <div style="float: left; margin-right: 6px;">
                      <feather-icon icon="CircleIcon" :svgClasses="['fill-current h-4 w-4 text-success']" />
                    </div>
                    <div style="float: left;">
                      <span>Escrita</span>
                    </div>
                  </div>
                </div>
                <vs-divider />
              </div>
            </div>
            <vs-table :data="roleListSliced">
              <template>
                <vs-tr v-for="roleItem in roleListSliced" :key="roleItem.hash">
                  <vs-td v-for="role in roleItem" :key="role.hash" style="width: 33.3%!important;">
                    <label class="vs-input--label" style="font-size: 15px;">{{ role.name }}</label>
                    <div>
                      <div>
                        <vs-slider max="2" :id="`slider-${role.hash}`" v-model="rolePermissions[role.hash]" @input="sliderChange(`${role.hash}`, $event)" style="width: 12% !important; min-width: 0px !important; float: left;" />
                      </div>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </tab-content>
      </form-wizard>
    </vs-popup>

    <vs-popup id="update-field" title="Editar Campo" :active.sync="editFieldPopUpActive">
      <form-wizard color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null" finishButtonText="Submit" @on-complete="editFormSubmitted">
          <tab-content title="Dados Básicos" class="mb-5" :before-change="validateStep1Edit">
              <!-- tab 1 content -->
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full">
                  <label class="vs-input--label">Tipo</label>
                  <v-select v-model="fieldEditData.type" disabled class="field-type-select" :clearable="false" @input="onFieldEditTypeChange" :options="fieldEditData.typeOptions" label="name" name="columnsOnForm" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <label class="vs-input--label">Colunas no formulário</label>
                  <v-select v-model="fieldEditData.columnsOnForm" :clearable="false" :options="fieldEditData.columnsOnFormOptions" name="columnsOnForm" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                </div>
              </div>

              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full mt-5">
                  <vs-input label="Nome" v-model="fieldEditData.name" class="w-full"/>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5">
                  <vs-input label="Legenda"  v-model="fieldEditData.subtitle" class="w-full"/>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5">
                  <ul class="switch-container">
                    <li>
                      <label class="vs-input--label">Mostrar Dica</label>
                      <vs-switch v-model="fieldEditData.showHint" class="mt-1 ml-1"/>
                    </li>
                  </ul>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5">
                  <vs-input type="email" label="Dica"  v-model="fieldEditData.hint" v-show="fieldEditData.showHint" class="w-full" />
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full mt-5"></div>
              </div>
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full mt-5"></div>
              </div>
          </tab-content>

          <tab-content title="Geral" class="mb-5" :before-change="validateStep2Edit">
            <div class="vx-row" v-if="fieldEditData.type.id === 25">
              <div class="vx-col md:w-1/2 w-full">
                <label class="vs-input--label">Relacionado ao módulo</label>
                <v-select v-model="fieldEditData.relatedModule" class="field-type-select" :clearable="false" :options="fieldEditData.moduleOptions" @input="onRelatedModuleEditChange" label="name" name="related-module" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <label class="vs-input--label">Relacionado ao campo</label>
                <v-select v-model="fieldEditData.relatedField" class="field-type-select" :clearable="false" :options="fieldEditData.moduleFieldOptions" label="name" name="related-module-field" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
              </div>
              <div class="vx-col mt-2 md:w-1/2 w-full">
                <label class="vs-input--label">Depende do campo</label>
                <v-select v-model="fieldEditData.dependentField" class="field-type-select" :clearable="true" :options="fieldEditData.relatedFieldOptions" label="name" name="related-module-field" :disabled="fieldEditData.dependentDisable" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
              </div>
            </div>
            <div class="vx-row" v-if="fieldEditData.type.id == 24">
              <div class="vx-col md:w-1/2 w-full">
                <h6 class="mt-5 mb-3">Inserir Item</h6>
                <vx-input-group class="mb-base mt-5">
                  <vs-input v-model="editOptionValue" maxlength="100" @keypress.enter="addOptionEditForm"/>
                  <template slot="append">
                    <div class="append-text btn-addon">
                      <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus" @click="addOptionEditForm"></vs-button>
                    </div>
                  </template>
                </vx-input-group>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <h6 class="mt-5 mb-3">Itens da Lista</h6>
                <draggable :list="fieldEditData.options" :group="{name:'tags',  pull:'clone', put:false }" class="p-2 cursor-move">
                  <vs-chip color="primary" style="padding-left: 20px!important; padding-right: 20px!important;font-size: 1.0rem!important; min-width: 70px!important; min-height: 35px!important;" v-for="(listItem, index) in fieldEditData.options" :key="index">
                    <feather-icon icon="XIcon" svgClasses="h-4 w-4 text-outline" class="mr-3" @click="removeItemEditForm(index)" style="cursor: pointer!important; margin-left: -10px!important;"></feather-icon> {{ listItem }} </vs-chip>
                </draggable>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full mt-5" v-if="showPlaceholder.includes(fieldEditData.type.id)">
                <vs-input type="text" label="Placeholder" v-model="fieldEditData.placeholder" class="w-full" />
              </div>
              <div class="vx-col mt-5" v-if="fieldEditData.type.id === 20 || fieldEditData.type.id === 18">
                <label class="vs-input--label"> Casas Decimais </label>
                <vs-input-number v-model="fieldEditData.decimals" min="1" max="6"/>
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5" v-if="fieldEditData.type.id === 1 || fieldEditData.type.id === 2 || fieldEditData.type.id === 3 || fieldEditData.type.id === 16 || fieldEditData.type.id === 19 || fieldEditData.type.id === 23">
                <vs-input type="text" v-if="fieldEditData.type.id === 1 || fieldEditData.type.id === 2 || fieldEditData.type.id === 3 || fieldEditData.type.id === 16 || fieldEditData.type.id === 19" label="Valor Padrão"  v-model="fieldEditData.defaultValue" class="w-full"/>
                <ul class="switch-container" v-else-if="fieldEditData.type.id === 23">
                  <li>
                    <label class="vs-input--label">Valor Padrão</label>
                    <vs-switch v-model="fieldEditData.defaultValue" class="mt-1 ml-1"/>
                  </li>
                </ul>
              </div>

              <div class="vx-col md:w-1/2 w-full mt-5" v-show="showMinAndMaxValueInt.includes(fieldEditData.type.id)">
                <vs-input type="number" label="Valor Mínimo" v-model="fieldEditData.minValueInt" class="w-full" />
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5" v-show="showMinAndMaxValueInt.includes(fieldEditData.type.id)">
                <vs-input type="number" label="Valor Máximo"  v-model="fieldEditData.maxValueInt" class="w-full" />
              </div>

              <div class="vx-col md:w-1/2 w-full mt-5" v-show="showMinAndMaxValueDate.includes(fieldEditData.type.id)">
                <label class="vs-input--label"> Valor Mínimo </label>
                <flat-pickr  v-model="fieldEditData.minValueDate" :config="{ dateFormat: 'd/m/Y' }" class="w-full" name="dob" />
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5" v-show="showMinAndMaxValueDate.includes(fieldEditData.type.id)">
                <label class="vs-input--label"> Valor Máximo </label>
                <flat-pickr  v-model="fieldEditData.maxValueDate" :config="{ dateFormat: 'd/m/Y' }" class="w-full" name="dob" />
              </div>

              <div class="vx-col md:w-1/2 w-full mt-5" v-show="showMinAndMaxValueDateTime.includes(fieldEditData.type.id)">
                <label class="vs-input--label"> Valor Mínimo </label>
                <flat-pickr  v-model="fieldEditData.minValueDateTime" :config="{ dateFormat: 'd/m/Y H:i:S', enableTime: true, enableSeconds: true, time_24hr: true }" class="w-full" name="dob" />
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5" v-show="showMinAndMaxValueDateTime.includes(fieldEditData.type.id)">
                <label class="vs-input--label"> Valor Máximo </label>
                <flat-pickr  v-model="fieldEditData.maxValueDateTime" :config="{ dateFormat: 'd/m/Y H:i:S', enableTime: true, enableSeconds: true, time_24hr: true }" class="w-full" name="dob" />
              </div>


              <!-- Min and Max Value -->
              <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldEditData.type.id === 1">
                <vs-input type="text" label="Máscara"  v-model="fieldEditData.mask" class="w-full" />
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5" v-show="showLengthField.includes(fieldEditData.type.id)">
                <vs-input type="number" label="Tamanho"  v-model="fieldEditData.length" class="w-full" />
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5" v-show="(fieldEditData.type.id >= 4 && fieldEditData.type.id <= 15) || (fieldEditData.type.id >= 17 && fieldEditData.type.id <= 19)"></div>
              <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldEditData.type.id === 25">
                  <ul class="switch-container">
                    <li>
                      <label class="vs-input--label">Exibir Aba Relacionada</label>
                      <vs-switch v-model="fieldEditData.relatedTab" class="mt-1 ml-1"/>
                    </li>
                  </ul>
                </div>
              <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldEditData.type.id !== 21 && fieldEditData.type.id !== 22">
                <ul class="switch-container">
                  <li>
                    <label class="vs-input--label">Criação Rápida</label>
                    <vs-switch v-model="fieldEditData.quickCreate" class="mt-1 ml-1"/>
                  </li>
                </ul>
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldEditData.type.id !== 21 && fieldEditData.type.id !== 22">
                <ul class="switch-container">
                  <li>
                    <label class="vs-input--label">Edição em Massa</label>
                    <vs-switch v-model="fieldEditData.massEdit" class="mt-1 ml-1"/>
                  </li>
                </ul>
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldEditData.type.id >= 3 && fieldEditData.type.id <= 18">
                <ul class="switch-container">
                  <li>
                    <label class="vs-input--label">Exibir Ícone</label>
                    <vs-switch v-model="fieldEditData.showIcon" class="mt-1 ml-1"/>
                  </li>
                </ul>
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5">
                <ul class="switch-container">
                  <li>
                    <label class="vs-input--label">Obrigatório</label>
                    <vs-switch v-model="fieldEditData.mandatory" class="mt-1 ml-1"/>
                  </li>
                </ul>
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5">
                <ul class="switch-container">
                  <li>
                    <label class="vs-input--label">Linha inteira</label>
                    <vs-switch v-model="fieldEditData.entireLine" class="mt-1 ml-1"/>
                  </li>
                </ul>
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldEditData.type.id !== 21 && fieldEditData.type.id !== 22">
                  <ul class="switch-container">
                    <li>
                      <label class="vs-input--label">Valor Único</label>
                      <vs-switch v-model="fieldEditData.unique" class="mt-1 ml-1" disabled/>
                    </li>
                  </ul>
                </div>
              <div class="vx-col md:w-1/2 w-full mt-5" v-show="showSecretField.includes(fieldEditData.type.id)">
                <ul class="switch-container">
                  <li>
                    <label class="vs-input--label">Secreto</label>
                    <vs-switch v-model="fieldEditData.secret" class="mt-1 ml-1"/>
                  </li>
                </ul>
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5" v-show="fieldEditData.type.id === 16">
                <ul class="switch-container">
                  <li>
                    <label class="vs-input--label">Exibir Progress Bar</label>
                    <vs-switch v-model="fieldEditData.showProgressBar" class="mt-1 ml-1"/>
                  </li>
                </ul>
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5"></div>
              <div class="vx-col md:w-1/2 w-full mt-5"></div>
            </div>
          </tab-content>

          <!-- tab 2 content -->
          <tab-content title="Permissões" class="mb-5">
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="flex items-end px-3">
                  <feather-icon svgClasses="w-6 h-6" icon="LockIcon" class="mr-2" />
                  <span class="font-medium text-lg leading-none">Selecione a permissão do campo nos cargos</span>
                </div>
                <div style="float: right;">
                  <div style="float: left; margin-right: 12px;">
                    <div style="float: left; margin-right: 6px;">
                      <feather-icon icon="CircleIcon" :svgClasses="['fill-current h-4 w-4 text-dark']" />
                    </div>
                    <div style="float: left;">
                      <span>Oculto</span>
                    </div>
                  </div>
                  <div style="float: left; margin-right: 12px;">
                    <div style="float: left; margin-right: 6px;">
                      <feather-icon icon="CircleIcon" :svgClasses="['fill-current h-4 w-4 text-primary']" />
                    </div>
                    <div style="float: left;">
                      <span>Somente Leitura</span>
                    </div>
                  </div>
                  <div style="float: left; margin-right: 12px;">
                    <div style="float: left; margin-right: 6px;">
                      <feather-icon icon="CircleIcon" :svgClasses="['fill-current h-4 w-4 text-success']" />
                    </div>
                    <div style="float: left;">
                      <span>Escrita</span>
                    </div>
                  </div>
                </div>
                <vs-divider />
              </div>
            </div>
            <vs-table :data="roleListSlicedEdit">
              <template>
                <vs-tr v-for="roleItem in roleListSlicedEdit" :key="roleItem.hash">
                  <vs-td v-for="role in roleItem" :key="role.hash" style="width: 33.3%!important;">
                    <label class="vs-input--label" style="font-size: 14px;">{{ role.name }}</label>
                    <div>
                      <div>
                        <vs-slider max="2" :id="`slider-edit-${role.hash}`" v-model="rolePermissionsEdit[role.hash]" @input="sliderEditChange(`${role.hash}`, $event)" style="width: 12% !important; min-width: 0px !important; float: left;" />
                      </div>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </tab-content>
      </form-wizard>
    </vs-popup>

    <vx-card :title="'Módulo: ' + this.moduleInfo['name']" save-layout @saveLayoutClicked="updateLayout">
      <draggable class="cursor-move mt-3" group="cards" :animation="700" draggable=".is-card">
        <vx-card :title="blockObject[block.hash].title" class="mt-3 is-card is-block" v-for="block in blockData" :key="block.hash" :id="'block-' + block.hash" @dragover.prevent @drop="dropItem" :add-action="block.hash" :pencil-action="block.hash" :trash-action="block.hash" @addButtonClicked="addButtonClicked" @trashButtonClicked="deleteBlockConfirm" @editButtonClicked="editBlockClicked">
          <draggable class="p-2 cursor-move vx-row mt-3" group="blocks" :animation="700">
            <div :class="'vx-col ' + fieldColumn(field.columns_on_form) + ' mt-3'" group="fields" v-for="field in block.fields" :key="field.hash" :id="field.hash" @dragstart="dragStart">
              <vx-card :title="field.title" :pencil-action="field.core ? '' : field.hash" @editButtonClicked="editFieldClicked" @trashButtonClicked="deleteFieldConfirm" :trash-action="field.core ? '' : field.hash" class="is-field">
                <div class="vx-row">
                  <div class="vx-col w-full">
                    <vs-input style="width: 100% !important;" disabled :placeholder="field.placeholder" />
                    <small class="form-text text-muted mt-3" style="display: block;">{{ field.subtitle }}</small>
                    <span style="float: right">Campo do tipo: <b>{{ field.type_name }}</b></span>
                  </div>
                </div>
              </vx-card>
            </div>
          </draggable>
        </vx-card>
      </draggable>
    </vx-card>
  </div>

</template>

<script>
import vSelect from 'vue-select'

// Store Module
import draggable from 'vuedraggable'
import {FormWizard, TabContent} from 'vue-form-wizard'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { PlusCircleIcon } from 'vue-feather-icons'
import { performFetch } from '../../../helpers.js'


export default {
  components: {
    vSelect,
    draggable,
    FormWizard,
    TabContent,
    PlusCircleIcon,
    flatPickr
  },
  data () {
    return {
      optionValue: '',
      editOptionValue: '',
      unsavedLayout: false,
      blockEditDataObject: {
        hash: '',
        title: '',
        collapsed: false,
        visible: false,
        roles: []
      },
      blockAddDataObject: {
        title: '',
        collapsed: false,
        visible: true,
        roles: []
      },
      fieldEditData: {
        dependentDisable: true,
        dependentField: {},
        relatedFieldOptions: [],
        options: [],
        relatedTab: false,
        moduleOptions: [],
        moduleFieldOptions: [],
        showProgressBar: false,
        relatedModule: {},
        relatedField: {},
        disableAll: true,
        type: {id: 0, name: ''},
        name: '',
        subtitle: null,
        placeholder: null,
        defaultValue: null,
        showHint: false,
        decimals: 2,
        hint: null,
        length: null,
        mask: null,
        columnsOnForm: 1,
        minValue: null,
        maxValue: null,
        minValueInt: null,
        maxValueInt: null,
        minValueDate: null,
        maxValueDate: null,
        minValueDateTime: null,
        maxValueDateTime: null,
        quickCreate: false,
        massEdit: false,
        showIcon: false,
        mandatory: false,
        entireLine: false,
        unique: false,
        secret: false,
        columnsOnFormOptions: [
          1,
          2,
          3,
          4
        ],
        typeOptions: []
      },
      fieldData: {
        dependentDisable: true,
        dependentField: {},
        relatedFieldOptions: [],
        options: ['Adicione um item...'],
        relatedTab: false,
        showProgressBar: false,
        moduleOptions: [],
        moduleFieldOptions: [],
        relatedModule: {},
        relatedField: {},
        disableAll: true,
        type: {id: 0, name: ''},
        name: '',
        subtitle: null,
        placeholder: null,
        defaultValue: null,
        showHint: false,
        decimals: 2,
        hint: null,
        length: null,
        columnsOnForm: 1,
        minValue: null,
        maxValue: null,
        minValueInt: null,
        maxValueInt: null,
        minValueDate: null,
        maxValueDate: null,
        minValueDateTime: null,
        maxValueDateTime: null,
        mask: null,
        quickCreate: false,
        massEdit: false,
        showIcon: false,
        mandatory: false,
        entireLine: false,
        unique: false,
        secret: false,
        columnsOnFormOptions: [
          1,
          2,
          3,
          4
        ],
        typeOptions: []
      },
      rolePermissions: {},
      rolePermissionsEdit: {},
      roleList: [],
      roleListSliced: [],
      roleListSlicedEdit: [],
      addFieldForm: {},
      dragItems: {},
      addFieldPopUpActive: false,
      editFieldPopUpActive: false,
      editBlockPopUpActive: false,
      addBlockPopUpActive: false,
      dropElementBlock: '',
      dropElement: '',
      blockData: [],
      blockObject: {},
      moduleInfo: {
        name: '',
        maxColumns: ''
      },
      max_columns: 4,
      currentFieldToDelete: '',
      currentBlockToDelete: '',
      currentBlockToAddField: '',
      showPlaceholder: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
      showLengthField: [1, 19],
      showMinAndMaxValueInt: [2],
      showSecretField: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 14, 15, 16, 18, 20],
      showMinAndMaxValueDate: [12],
      showMinAndMaxValueDateTime: [13],
      showMinAndMaxValueTime: []
    }
  },
  watch: {
    // 'fieldData.defaultValue' (value) {
    //   console.log(value)
    // },
    addFieldPopUpActive(value) {
      if(!value) {
        this.resetNewFieldForm()
      }
    },
    statusFilter (obj) {
      this.setColumnFilter('status', obj.value)
    },
    isVerifiedFilter (obj) {
      const val = obj.value === 'all' ? 'all' : obj.value === 'yes' ? 'true' : 'false'
      this.setColumnFilter('is_verified', val)
    },
    departmentFilter (obj) {
      this.setColumnFilter('department', obj.value)
    }
  },
  computed: {
    onChangeEditBlockPopUp: {
      get () {
        return this.editBlockPopUpActive
      },
      set (val) {
        if (val === false) {

          this.blockObject[this.blockEditDataObject['hash']]['title'] = this.blockEditDataObject['title']
          this.blockObject[this.blockEditDataObject['hash']]['collapsed'] = this.blockEditDataObject['collapsed']
          this.blockObject[this.blockEditDataObject['hash']]['visible'] = this.blockEditDataObject['visible']
          this.blockObject[this.blockEditDataObject['hash']]['roles'] = Array.isArray(this.blockEditDataObject['roles']) ? this.blockEditDataObject['roles'] : []

          this.unsavedLayout = true

        }
        this.editBlockPopUpActive = val
      }
    },
    modulesData () {
      return this.$store.state.customModules.modules
    },
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    addOptionEditForm() {
      if(this.editOptionValue !== '') {
        this.fieldEditData.options.push(this.editOptionValue)
        this.editOptionValue = ''
      } else {
        this.$vs.notify({
          title: 'Atenção',
          text: 'A lista precisa ter pelo menos 1 item!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      }
    },
    addOptionAddForm() {

      if(this.optionValue !== '') {
        if(this.fieldData.options[0] === 'Adicione um item...') {
          this.fieldData.options = []
        }
        this.fieldData.options.push(this.optionValue)
        this.optionValue = ''
      } else {
        this.$vs.notify({
          title: 'Atenção',
          text: 'O item não pode ser vazio!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      }
    },
    removeItemEditForm(index) {
      this.fieldEditData.options.splice(index, 1)
    },
    removeItemAddForm(index) {
      this.fieldData.options.splice(index, 1)
    },
    async onRelatedModuleEditChange(val) {
      this.$vs.loading({type: 'default'})

      this.getRelatedFields(this.$route.params.moduleHash, val.hash, 'edit')

      // fetch(`${this.$store.state.auth.api_url}`, {
      //     method: 'POST', headers: {"Content-Type": "application/json"},
      //     body: JSON.stringify({
      //       command: 'module_management_get_application_module_fields',
      //       parameters: {
      //         application_token: this.$store.state.auth.app_token,
      //         session_token: this.$store.state.auth.token,
      //         module_token: val.hash
      //       }
      //     })
      //   })
      await performFetch(`${this.$store.state.auth.api_url}`, {
          command: 'module_management_get_application_module_fields',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            module_token: val.hash
          }
        })
        .then(async (response) => {
          this.$vs.loading.close()
          if (response.status === 200) {

            response.json().then(responseData => {

              const moduleFieldList = []

              responseData.module.payload.forEach((item) => {
                item.fields.forEach((fieldItem) => {
                  const fieldObject = {
                    hash: fieldItem.hash,
                    name: fieldItem.title
                  }

                  if(fieldItem.type_id !== 24 && fieldItem.type_id !== 25) {
                    moduleFieldList.push(fieldObject)
                  }
                })
              })

              moduleFieldList.sort((a, b) => {
                if(a.name < b.name) { return -1; }
                if(a.name > b.name) { return 1; }
                return 0;
              })

              this.fieldEditData.moduleFieldOptions = moduleFieldList

              this.$vs.loading.close()
            })

          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Operação não realizada!',
              text: 'Ocorreu um erro ao buscar os módulos da aplicação!',
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'danger'
            })
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Operação não realizada!',
            text: 'Ocorreu um erro ao buscar os módulos da aplicação!',
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'danger'
          })
          throw new Error(e.message)
        })

    },
    async getRelatedFields(moduleToken, relatedModuleToken, action = 'add') {
      // fetch(`${this.$store.state.auth.api_url}`, {
      //     method: 'POST', headers: {"Content-Type": "application/json"},
      //     body: JSON.stringify({
      //       command: 'get_module_related_fields',
      //       parameters: {
      //         application_token: this.$store.state.auth.app_token,
      //         session_token: this.$store.state.auth.token,
      //         module_token: moduleToken,
      //         related_module_token: relatedModuleToken
      //       }
      //     })
      //   })
        await performFetch(`${this.$store.state.auth.api_url}`, {
            command: 'get_module_related_fields',
            parameters: {
              application_token: this.$store.state.auth.app_token,
              session_token: this.$store.state.auth.token,
              module_token: moduleToken,
              related_module_token: relatedModuleToken
            }
          })
        .then(async (response) => {
          this.$vs.loading.close()
          if (response.status === 200) {

            response.json().then(responseData => {

              const relatedFields = []

              responseData.payload.forEach((item) => {
                const fieldObject = {
                    hash: item.hash,
                    name: item.name
                  }

                relatedFields.push(fieldObject)
              })

              relatedFields.sort((a, b) => {
                if(a.name < b.name) { return -1; }
                if(a.name > b.name) { return 1; }
                return 0;
              })

              if(action === 'add') {
                this.fieldData.relatedFieldOptions = relatedFields

                if(Array.isArray(this.fieldData.relatedFieldOptions) && this.fieldData.relatedFieldOptions.length > 0) {
                  this.fieldData.dependentDisable = false
                } else {
                  this.fieldData.dependentDisable = true
                }

                this.fieldData.dependentField = {}
              } else {
                this.fieldEditData.relatedFieldOptions = relatedFields

                if(Array.isArray(this.fieldEditData.relatedFieldOptions) && this.fieldEditData.relatedFieldOptions.length > 0) {
                  this.fieldEditData.dependentDisable = false
                } else {
                  this.fieldEditData.dependentDisable = true
                }
              }

              this.$vs.loading.close()
            })

          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Operação não realizada!',
              text: 'Ocorreu um erro ao buscar os módulos da aplicação!',
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'danger'
            })
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Operação não realizada!',
            text: 'Ocorreu um erro ao buscar os módulos da aplicação!',
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    async onRelatedModuleChange(val) {

      this.getRelatedFields(this.$route.params.moduleHash, val.hash, 'add')

      this.$vs.loading({type: 'default'})

      // fetch(`${this.$store.state.auth.api_url}`, {
      //     method: 'POST', headers: {"Content-Type": "application/json"},
      //     body: JSON.stringify({
      //       command: 'module_management_get_application_module_fields',
      //       parameters: {
      //         application_token: this.$store.state.auth.app_token,
      //         session_token: this.$store.state.auth.token,
      //         module_token: val.hash
      //       }
      //     })
      //   })
        await performFetch(`${this.$store.state.auth.api_url}`, {
            command: 'module_management_get_application_module_fields',
            parameters: {
              application_token: this.$store.state.auth.app_token,
              session_token: this.$store.state.auth.token,
              module_token: val.hash
            }
          })
        .then(async (response) => {
          this.$vs.loading.close()
          if (response.status === 200) {

            response.json().then(responseData => {

              const moduleFieldList = []

              responseData.module.payload.forEach((item) => {
                item.fields.forEach((fieldItem) => {
                  const fieldObject = {
                    hash: fieldItem.hash,
                    name: fieldItem.title
                  }

                  if(fieldItem.type_id !== 24 && fieldItem.type_id !== 25) {
                    moduleFieldList.push(fieldObject)
                  }
                })
              })

              moduleFieldList.sort((a, b) => {
                if(a.name < b.name) { return -1; }
                if(a.name > b.name) { return 1; }
                return 0;
              })

              this.fieldData.moduleFieldOptions = moduleFieldList

              this.$vs.loading.close()
            })

          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Operação não realizada!',
              text: 'Ocorreu um erro ao buscar os módulos da aplicação!',
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'danger'
            })
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Operação não realizada!',
            text: 'Ocorreu um erro ao buscar os módulos da aplicação!',
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    async onFieldEditTypeChange(val) {
      if(val.id === 25) {
        await performFetch(`${this.$store.state.auth.api_url}`, {
            command: 'module_management_get_application_modules',
            parameters: {
              application_token: this.$store.state.auth.app_token,
              session_token: this.$store.state.auth.token
            }
          })
        // fetch(`${this.$store.state.auth.api_url}`, {
        //   method: 'POST', headers: {"Content-Type": "application/json"},
        //   body: JSON.stringify({
        //     command: 'module_management_get_application_modules',
        //     parameters: {
        //       application_token: this.$store.state.auth.app_token,
        //       session_token: this.$store.state.auth.token
        //     }
        //   })
        // })
        .then(async (response) => {
          this.$vs.loading.close()
          if (response.status === 200) {

            response.json().then(responseData => {
              responseData.modules.forEach((item) => {

                if(item.hash !== this.$route.params.moduleHash) {
                  const moduleObject = {
                    hash: item.hash,
                    name: item.name
                  }

                  this.fieldEditData.moduleOptions.push(moduleObject)
                }
              })
            })

          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Operação não realizada!',
              text: 'Ocorreu um erro ao buscar os módulos da aplicação!',
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'danger'
            })
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Operação não realizada!',
            text: 'Ocorreu um erro ao buscar os módulos da aplicação!',
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'danger'
          })
          throw new Error(e.message)
        })
      }
    },
    async onFieldTypeChange(val) {
      val.id > 0 ? this.fieldData.disableAll = false : this.fieldData.disableAll = true

      if(val.id === 25) {
        // fetch(`${this.$store.state.auth.api_url}`, {
        //   method: 'POST', headers: {"Content-Type": "application/json"},
        //   body: JSON.stringify({
        //     command: 'module_management_get_application_modules',
        //     parameters: {
        //       application_token: this.$store.state.auth.app_token,
        //       session_token: this.$store.state.auth.token
        //     }
        //   })
        // })
        await performFetch(`${this.$store.state.auth.api_url}`, {
            command: 'module_management_get_application_modules',
            parameters: {
              application_token: this.$store.state.auth.app_token,
              session_token: this.$store.state.auth.token
            }
          })
        .then(async (response) => {
          this.$vs.loading.close()
          if (response.status === 200) {

            this.fieldData.moduleOptions = []

            response.json().then(responseData => {
              // this.fieldData.moduleOptions = responseData.modules

              responseData.modules.forEach((item) => {
                if(item.hash !== this.$route.params.moduleHash) {
                  const moduleObject = {
                    hash: item.hash,
                    name: item.name
                  }

                  this.fieldData.moduleOptions.push(moduleObject)
                }
              })
            })

          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Operação não realizada!',
              text: 'Ocorreu um erro ao buscar os módulos da aplicação!',
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'danger'
            })
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Operação não realizada!',
            text: 'Ocorreu um erro ao buscar os módulos da aplicação!',
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'danger'
          })
          throw new Error(e.message)
        })
      }
    },
    validateStep1Add () {

      if (this.fieldData.type.id === 0) {
        this.$vs.notify({
          title: 'Atenção',
          text: 'O campo Tipo é obrigatório',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (!this.fieldData.name) {
        this.$vs.notify({
          title: 'Atenção',
          text: 'O campo Nome é obrigatório',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (this.fieldData.showHint && !this.fieldData.hint) {
        this.$vs.notify({
          title: 'Atenção',
          text: 'Se o campo Mostrar Dica estiver selecionado, o campo Dica é obrigatório',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      return true
    },
    validateStep1Edit () {

      if (this.fieldEditData.type.id === 0) {
        this.$vs.notify({
          title: 'Atenção',
          text: 'O campo Tipo é obrigatório',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (!this.fieldEditData.name) {
        this.$vs.notify({
          title: 'Atenção',
          text: 'O campo Nome é obrigatório',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (this.fieldEditData.showHint && !this.fieldEditData.hint) {
        this.$vs.notify({
          title: 'Atenção',
          text: 'Se o campo Mostrar Dica estiver selecionado, o campo Dica é obrigatório',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      return true
    },
    validateStep2Add () {

      if(this.fieldData.type.id === 2) {
        if(this.fieldData.defaultValue && this.fieldData.defaultValue !== '') {

          let value = null

          value = parseInt(this.fieldData.defaultValue)

          if(isNaN(value)) {

            this.$vs.notify({
              title: 'Atenção',
              text: 'O campo valor padrão precisa ser numérico!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })

            return false
          }

          if(this.fieldData.minValueInt && value !== null && value < this.fieldData.minValueInt) {
            this.$vs.notify({
              title: 'Atenção',
              text: 'O campo valor padrão precisa atender aos critérios de valor mínimo e máximo!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })

            return false
          }

          if(this.fieldData.maxValueInt && value !== null && value > this.fieldData.maxValueInt) {
            this.$vs.notify({
              title: 'Atenção',
              text: 'O campo valor padrão precisa atender aos critérios de valor mínimo e máximo!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })

            return false
          }

        }
      }

      if(this.fieldData.type.id === 24 && (this.fieldData.options.length === 0 || (this.fieldData.options.length === 1 && this.fieldData.options[0] === 'Adicione um item...'))) {
        this.$vs.notify({
          title: 'Atenção',
          text: 'A lista precisa ter pelo menos 1 item!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if(this.showLengthField.includes(this.fieldData.type.id) && (parseInt(this.fieldData.length) > 3000 || parseInt(this.fieldData.length) < 0) && (this.fieldData.length !== '' || this.fieldData.length !== null || this.fieldData.length === 'e')) {
        this.$vs.notify({
          title: 'Atenção',
          text: 'O Campo Tamanho precisa estar entre 0 e 3000',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if((this.fieldData.type.id === 25) && !(Object.keys(this.fieldData.relatedModule).length === 0 && this.fieldData.relatedModule.constructor === Object) && (Object.keys(this.fieldData.relatedField).length === 0 && this.fieldData.relatedField.constructor === Object)) {
        this.$vs.notify({
          title: 'Atenção',
          text: 'O Campo Relacionado precisa ser preenchido',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if((this.fieldData.type.id === 25) && (Object.keys(this.fieldData.relatedModule).length === 0 && this.fieldData.relatedModule.constructor === Object)) {
        this.$vs.notify({
          title: 'Atenção',
          text: 'O Módulo Relacionado precisa ser preenchido',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (this.showMinAndMaxValueInt.includes(this.fieldData.type.id)) {

        if (this.fieldData.minValueInt && this.fieldData.maxValueInt) {
          if (parseInt(this.fieldData.minValueInt) > parseInt(this.fieldData.maxValueInt)) {
            this.$vs.notify({
              title: 'Atenção',
              text: 'O Valor Mínimo não pode ser maior que o Valor Máximo',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })

            return false
          }

          this.fieldData.minValue = this.fieldData.minValueInt
          this.fieldData.maxValue = this.fieldData.maxValueInt
        }

      } else if (this.showMinAndMaxValueDate.includes(this.fieldData.type.id)) {
        if (this.fieldData.minValueDate && this.fieldData.maxValueDate) {

          let minValueDateStr = ''
          let maxValueDateStr = ''

          try {
            minValueDateStr = `${this.fieldData.minValueDate.split('/')[2]}-${this.fieldData.minValueDate.split('/')[1]}-${this.fieldData.minValueDate.split('/')[0]}`
          } catch (e) {

          }

          try {
            maxValueDateStr = `${this.fieldData.maxValueDate.split('/')[2]}-${this.fieldData.maxValueDate.split('/')[1]}-${this.fieldData.maxValueDate.split('/')[0]}`
          } catch (e) {

          }

          if (minValueDateStr && maxValueDateStr) {
            const minValueDateObject = new Date(minValueDateStr)
            const maxValueDateObject = new Date(maxValueDateStr)

            if (minValueDateObject > maxValueDateObject) {
              this.$vs.notify({
                title: 'Atenção',
                text: 'O Valor Mínimo não pode ser maior que o Valor Máximo',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
              })

              return false
            }
          }

          this.fieldData.minValue = minValueDateStr
          this.fieldData.maxValue = maxValueDateStr

        }
      } else if (this.showMinAndMaxValueDateTime.includes(this.fieldData.type.id)) {
        if (this.fieldData.minValueDateTime && this.fieldData.maxValueDateTime) {

          let minValueDateStr = ''
          let maxValueDateStr = ''

          const minTime = this.fieldData.minValueDateTime.split(' ')[1].trim()
          const minDate = this.fieldData.minValueDateTime.split(' ')[0].trim()
          const maxTime = this.fieldData.maxValueDateTime.split(' ')[1].trim()
          const maxDate = this.fieldData.maxValueDateTime.split(' ')[0].trim()

          try {
            minValueDateStr = `${minDate.split('/')[2]}-${minDate.split('/')[1]}-${minDate.split('/')[0]}`
          } catch (e) {

          }

          try {
            maxValueDateStr = `${maxDate.split('/')[2]}-${maxDate.split('/')[1]}-${maxDate.split('/')[0]}`
          } catch (e) {

          }

          if (minValueDateStr && maxValueDateStr) {
            const minValueDateObject = new Date(`${minValueDateStr  } ${  minTime}`)
            const maxValueDateObject = new Date(`${maxValueDateStr  } ${  maxTime}`)

            if (minValueDateObject > maxValueDateObject) {
              this.$vs.notify({
                title: 'Atenção',
                text: 'O Valor Mínimo não pode ser maior que o Valor Máximo',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
              })

              return false
            }
          }

          this.fieldData.minValue = `${minValueDateStr  } ${  minTime}`
          this.fieldData.maxValue = `${maxValueDateStr  } ${  maxTime}`

        }
      }

      return true
    },
    validateStep2Edit () {

      if(this.fieldEditData.type.id === 2) {
        if(this.fieldEditData.defaultValue && this.fieldEditData.defaultValue !== '') {

          let value = null

          value = parseInt(this.fieldEditData.defaultValue)

          if(isNaN(value)) {

            this.$vs.notify({
              title: 'Atenção',
              text: 'O campo valor padrão precisa ser numérico!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })

            return false
          }

          if(this.fieldEditData.minValueInt && value !== null && value < this.fieldEditData.minValueInt) {
            this.$vs.notify({
              title: 'Atenção',
              text: 'O campo valor padrão precisa atender aos critérios de valor mínimo e máximo!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })

            return false
          }

          if(this.fieldEditData.maxValueInt && value !== null && value > this.fieldEditData.maxValueInt) {
            this.$vs.notify({
              title: 'Atenção',
              text: 'O campo valor padrão precisa atender aos critérios de valor mínimo e máximo!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })

            return false
          }
        }
      }

      if(this.fieldEditData.type.id === 24 && (this.fieldEditData.options.length === 0)) {
        this.$vs.notify({
          title: 'Atenção',
          text: 'A lista precisa ter pelo menos 1 item!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if(this.showLengthField.includes(this.fieldEditData.type.id) && (parseInt(this.fieldEditData.length) > 3000 || parseInt(this.fieldEditData.length) < 0) && (this.fieldEditData.length !== '' || this.fieldEditData.length !== null || this.fieldEditData.length === 'e')) {
        this.$vs.notify({
          title: 'Atenção',
          text: 'O Campo Tamanho precisa estar entre 0 e 3000',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if(this.fieldEditData.type.id === 25 && Object.keys(this.fieldEditData.relatedModule).length === 0 && this.fieldEditData.relatedModule.constructor === Object) {
        this.$vs.notify({
          title: 'Atenção',
          text: 'O Campo Módulo Relacionado precisa ser preenchido',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if((this.fieldEditData.type.id === 25) && !(Object.keys(this.fieldEditData.relatedModule).length === 0 && this.fieldEditData.relatedModule.constructor === Object) && (Object.keys(this.fieldEditData.relatedField).length === 0 && this.fieldEditData.relatedField.constructor === Object)) {
        this.$vs.notify({
          title: 'Atenção',
          text: 'O Campo Relacionado precisa ser preenchido',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (this.showMinAndMaxValueInt.includes(this.fieldEditData.type.id)) {

        if (this.fieldEditData.minValueInt && this.fieldEditData.maxValueInt) {
          if (parseInt(this.fieldEditData.minValueInt) > parseInt(this.fieldEditData.maxValueInt)) {
            this.$vs.notify({
              title: 'Atenção',
              text: 'O Valor Mínimo não pode ser maior que o Valor Máximo',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })

            return false
          }

          this.fieldEditData.minValue = this.fieldEditData.minValueInt
          this.fieldEditData.maxValue = this.fieldEditData.maxValueInt
        }

      } else if (this.showMinAndMaxValueDate.includes(this.fieldEditData.type.id)) {
        if (this.fieldEditData.minValueDate && this.fieldEditData.maxValueDate) {

          let minValueDateStr = ''
          let maxValueDateStr = ''

          try {
            minValueDateStr = `${this.fieldEditData.minValueDate.split('/')[2]}-${this.fieldEditData.minValueDate.split('/')[1]}-${this.fieldEditData.minValueDate.split('/')[0]}`
          } catch (e) {

          }

          try {
            maxValueDateStr = `${this.fieldEditData.maxValueDate.split('/')[2]}-${this.fieldEditData.maxValueDate.split('/')[1]}-${this.fieldEditData.maxValueDate.split('/')[0]}`
          } catch (e) {

          }

          if (minValueDateStr && maxValueDateStr) {
            const minValueDateObject = new Date(minValueDateStr)
            const maxValueDateObject = new Date(maxValueDateStr)

            if (minValueDateObject > maxValueDateObject) {
              this.$vs.notify({
                title: 'Atenção',
                text: 'O Valor Mínimo não pode ser maior que o Valor Máximo',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
              })

              return false
            }
          }

          this.fieldEditData.minValue = minValueDateStr
          this.fieldEditData.maxValue = maxValueDateStr

        }
      } else if (this.showMinAndMaxValueDateTime.includes(this.fieldEditData.type.id)) {
        if (this.fieldEditData.minValueDateTime && this.fieldEditData.maxValueDateTime) {

          let minValueDateStr = ''
          let maxValueDateStr = ''

          const minTime = this.fieldEditData.minValueDateTime.split(' ')[1].trim()
          const minDate = this.fieldEditData.minValueDateTime.split(' ')[0].trim()
          const maxTime = this.fieldEditData.maxValueDateTime.split(' ')[1].trim()
          const maxDate = this.fieldEditData.maxValueDateTime.split(' ')[0].trim()

          try {
            minValueDateStr = `${minDate.split('/')[2]}-${minDate.split('/')[1]}-${minDate.split('/')[0]}`
          } catch (e) {

          }

          try {
            maxValueDateStr = `${maxDate.split('/')[2]}-${maxDate.split('/')[1]}-${maxDate.split('/')[0]}`
          } catch (e) {

          }

          if (minValueDateStr && maxValueDateStr) {
            const minValueDateObject = new Date(`${minValueDateStr  } ${  minTime}`)
            const maxValueDateObject = new Date(`${maxValueDateStr  } ${  maxTime}`)

            if (minValueDateObject > maxValueDateObject) {
              this.$vs.notify({
                title: 'Atenção',
                text: 'O Valor Mínimo não pode ser maior que o Valor Máximo',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
              })

              return false
            }
          }

          this.fieldEditData.minValue = `${minValueDateStr  } ${  minTime}`
          this.fieldEditData.maxValue = `${maxValueDateStr  } ${  maxTime}`

        }
      }

      return true
    },
    async addBlock () {

      this.$vs.loading({type: 'default'})

      // fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'module_management_add_application_module_block',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       module_token: this.$route.params.moduleHash,
      //       block: {
      //         name: this.blockAddDataObject.title,
      //         collapsed: this.blockAddDataObject.collapsed,
      //         visible: this.blockAddDataObject.visible
      //       }
      //     }
      //   })
      // })
      await performFetch(`${this.$store.state.auth.api_url}`, {
          command: 'module_management_add_application_module_block',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            module_token: this.$route.params.moduleHash,
            block: {
              name: this.blockAddDataObject.title,
              collapsed: this.blockAddDataObject.collapsed,
              visible: this.blockAddDataObject.visible
            }
          }
        })
        .then(async (response) => {
          this.$vs.loading.close()
          if (response.status === 200) {

            this.addBlockPopUpActive = false

            this.$vs.loading.close()

            this.blockAddDataObject = {
              title: '',
              collapsed: false,
              visible: true
            },

            await this.loadData()

            this.$vs.notify({
              title: 'Operação realizada!',
              text: 'Bloco adicionado com sucesso!',
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Operação não realizada!',
              text: 'Ocorreu um erro ao adicionar o bloco!',
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'danger'
            })
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Operação não realizada!',
            text: 'Ocorreu um erro ao adicionar o bloco!',
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    addBlockCall () {

      this.addBlockPopUpActive = true

      document.querySelectorAll('div.vs-popup').forEach((item) => {
        if (item.children[1].children[0].id === 'add-block' || item.children[1].children[0].id === 'edit-block') {
          // item.style.width = '500px'
          item.children[1].style.width = '500px'
          item.setAttribute('style', 'width: 500px!important')
        }
      })
    },
    sliderChange (elementId, e) {
      if (e === 0) {
        document.querySelector(`#slider-${elementId}`).classList.remove('vs-slider-primary')
        document.querySelector(`#slider-${elementId}`).classList.remove('vs-slider-success')
        document.querySelector(`#slider-${elementId}`).classList.remove('vs-slider-dark')
        document.querySelector(`#slider-${elementId}`).classList.add('vs-slider-dark')
      } else if (e === 1) {
        document.querySelector(`#slider-${elementId}`).classList.remove('vs-slider-dark')
        document.querySelector(`#slider-${elementId}`).classList.remove('vs-slider-success')
        document.querySelector(`#slider-${elementId}`).classList.remove('vs-slider-primary')
        document.querySelector(`#slider-${elementId}`).classList.add('vs-slider-primary')
      } else {
        document.querySelector(`#slider-${elementId}`).classList.remove('vs-slider-dark')
        document.querySelector(`#slider-${elementId}`).classList.remove('vs-slider-primary')
        document.querySelector(`#slider-${elementId}`).classList.remove('vs-slider-success')
        document.querySelector(`#slider-${elementId}`).classList.add('vs-slider-success')
      }
    },
    sliderEditChange (elementId, e) {
      if (e === 0) {
        document.querySelector(`#slider-edit-${elementId}`).classList.remove('vs-slider-primary')
        document.querySelector(`#slider-edit-${elementId}`).classList.remove('vs-slider-success')
        document.querySelector(`#slider-edit-${elementId}`).classList.remove('vs-slider-dark')
        document.querySelector(`#slider-edit-${elementId}`).classList.add('vs-slider-dark')
      } else if (e === 1) {
        document.querySelector(`#slider-edit-${elementId}`).classList.remove('vs-slider-dark')
        document.querySelector(`#slider-edit-${elementId}`).classList.remove('vs-slider-success')
        document.querySelector(`#slider-edit-${elementId}`).classList.remove('vs-slider-primary')
        document.querySelector(`#slider-edit-${elementId}`).classList.add('vs-slider-primary')
      } else {
        document.querySelector(`#slider-edit-${elementId}`).classList.remove('vs-slider-dark')
        document.querySelector(`#slider-edit-${elementId}`).classList.remove('vs-slider-primary')
        document.querySelector(`#slider-edit-${elementId}`).classList.remove('vs-slider-success')
        document.querySelector(`#slider-edit-${elementId}`).classList.add('vs-slider-success')
      }
    },
    async updateLayout () {

      this.$vs.loading({type: 'default'})

      const blockLayoutList = []

      document.querySelectorAll('.is-block').forEach((item, key) => {

        const blockHash = item.id.split('block-')[1]

        const blockIndex = key + 1

        const blockObject = {}

        blockObject['block_hash'] = blockHash
        blockObject['block_index'] = blockIndex
        blockObject['block_collapsed'] = this.blockObject[blockHash].collapsed
        blockObject['block_visible'] = this.blockObject[blockHash].visible
        blockObject['block_title'] = this.blockObject[blockHash].title
        blockObject['block_roles'] = Array.isArray(this.blockObject[blockHash].roles) ? this.blockObject[blockHash].roles : []

        blockObject['fields'] = []

        item.querySelector('.vx-card').querySelector('.vx-card__collapsible-content.vs-con-loading__container').querySelector('.vx-card__body').children[0].children.forEach((fieldItem, fieldKey) => {

          const fieldHash = fieldItem.id

          const fieldIndex = fieldKey + 1

          blockObject['fields'].push({
            field_hash: fieldHash,
            field_index: fieldIndex
          })

        })

        blockLayoutList.push(blockObject)
      })

      // fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'module_management_update_module_fields_layout',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       module_token: this.$route.params.moduleHash,
      //       blocks: blockLayoutList
      //     }
      //   })
      // })
      await performFetch(`${this.$store.state.auth.api_url}`, {
          command: 'module_management_update_module_fields_layout',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            module_token: this.$route.params.moduleHash,
            blocks: blockLayoutList
          }
        })
        .then(async (response) => {
          this.$vs.loading.close()
          if (response.status === 200) {

            this.unsavedLayout = false

            this.$vs.notify({
              title: 'Operação realizada!',
              text: 'Layout atualizado com sucesso!',
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.notify({
              title: 'Operação realizada!',
              text: 'Ocorreu um erro ao atualizar o layout!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })

            this.unsavedLayout = true
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Operação realizada!',
            text: 'Ocorreu um erro ao atualizar o layout!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    editBlockClicked (elementHash) {
      this.editBlockPopUpActive = true

      const currentBlock = this.blockObject[elementHash]

      this.blockEditDataObject.hash = currentBlock.hash
      this.blockEditDataObject.title = currentBlock.title
      this.blockEditDataObject.collapsed = currentBlock.collapsed
      this.blockEditDataObject.visible = currentBlock.visible
      this.blockEditDataObject.roles = Array.isArray(currentBlock.roles) ? [...currentBlock.roles] : []
    },
    async editFieldClicked (elementHash) {

      document.querySelectorAll('.wizard-nav.wizard-nav-pills')[0].querySelectorAll('li')[0].click()

      this.$vs.loading({type: 'default'})

      // fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'module_management_get_application_module_field_detail',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       module_token: this.$route.params.moduleHash,
      //       field_token: elementHash
      //     }
      //   })
      // })
      await performFetch(`${this.$store.state.auth.api_url}`, {
          command: 'module_management_get_application_module_field_detail',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            module_token: this.$route.params.moduleHash,
            field_token: elementHash
          }
        })
        .then(async (response) => {
          this.$vs.loading.close()
          if (response.status === 200) {
            response.json().then(async (responseData) => {

              const fieldData = responseData.field

              const typeObject = this.fieldData.typeOptions.find(o => o.id === responseData.field.type_id)

              this.fieldEditData.options = []

              this.fieldEditData.hash = fieldData.hash
              this.fieldEditData.type = typeObject

              this.fieldEditData.name = fieldData.title
              this.fieldEditData.subtitle = fieldData.subtitle
              this.fieldEditData.placeholder = fieldData.place_holder
              this.fieldEditData.defaultValue = fieldData.defaultValue
              this.fieldEditData.showHint = fieldData.show_hint
              this.fieldEditData.decimals = fieldData.decimals
              this.fieldEditData.defaultValue = fieldData.default_value
              this.fieldEditData.mask = fieldData.mask
              this.fieldEditData.hint = fieldData.hint
              this.fieldEditData.length = fieldData.length
              this.fieldEditData.columnsOnForm = fieldData.columns_on_form
              this.fieldEditData.minValue = fieldData.min_value
              this.fieldEditData.maxValue = fieldData.max_value
              this.fieldEditData.quickCreate = fieldData.quick_create
              this.fieldEditData.massEdit = fieldData.mass_edit
              this.fieldEditData.showIcon = fieldData.show_icon
              this.fieldEditData.unique = fieldData.unique
              this.fieldEditData.mandatory = fieldData.mandatory
              this.fieldEditData.entireLine = fieldData.entire_line
              this.fieldEditData.showProgressBar = fieldData.show_progress_bar
              this.fieldEditData.secret = fieldData.secret
              this.fieldEditData.options = fieldData.options
              this.fieldEditData.relatedTab = fieldData.has_related_tab

              if(this.fieldEditData.type.id === 25) {
                this.fieldEditData.relatedModule = fieldData.related_module

                this.onFieldEditTypeChange(typeObject)
                this.onRelatedModuleEditChange(fieldData.related_module)

                this.fieldEditData.relatedField = fieldData.related_module_field
                if(fieldData.related_parent !== null && fieldData.related_parent !== undefined) {
                  this.fieldEditData.dependentField = fieldData.related_parent
                }
              }

              if (fieldData.type_id === 12) {

                let minValueFormatted = ''
                let maxValueFormatted = ''

                if (fieldData.min_value) {
                  minValueFormatted = `${fieldData.min_value.split('-')[2]}/${fieldData.min_value.split('-')[1]}/${fieldData.min_value.split('-')[0]}`
                }

                if (fieldData.max_value) {
                  maxValueFormatted = `${fieldData.max_value.split('-')[2]}/${fieldData.max_value.split('-')[1]}/${fieldData.max_value.split('-')[0]}`
                }

                this.fieldEditData.minValueDate = minValueFormatted
                this.fieldEditData.maxValueDate = maxValueFormatted
              } else if (fieldData.type_id == 13) {

                let minValueFormatted = ''
                let maxValueFormatted = ''

                if (fieldData.min_value) {
                  minValueFormatted = `${fieldData.min_value.split(' ')[0].trim().split('-')[2]}/${fieldData.min_value.split(' ')[0].split('-')[1]}/${fieldData.min_value.split(' ')[0].split('-')[0]} ${fieldData.min_value.split(' ')[1]}`
                }

                if (fieldData.max_value) {
                  maxValueFormatted = `${fieldData.max_value.split(' ')[0].split('-')[2]}/${fieldData.max_value.split(' ')[0].split('-')[1]}/${fieldData.max_value.split(' ')[0].split('-')[0]} ${fieldData.max_value.split(' ')[1]}`
                }

                this.fieldEditData.minValueDateTime = minValueFormatted
                this.fieldEditData.maxValueDateTime = maxValueFormatted
              } else if (fieldData.type_id == 2) {
                this.fieldEditData.minValueInt = fieldData.min_value
                this.fieldEditData.maxValueInt = fieldData.max_value
              }

              const clearedRoles = []

              this.roleList.forEach((item) => {
                if (Object.keys(fieldData.permissions).includes(item.hash)) {
                  clearedRoles.push(item)
                }
              })

              const data = []

              let i, j, temparray, chunk = 3

              for (i = 0, j = clearedRoles.length; i < j; i += chunk) {
                temparray = clearedRoles.slice(i, i + chunk)

                data.push(temparray)
              }

              this.roleListSlicedEdit = data

              setTimeout(() => {
                Object.keys(fieldData.permissions).forEach((item) => {

                  const roleHash = item

                  if (fieldData.permissions[roleHash].can_edit && fieldData.permissions[roleHash].visible) {
                    this.rolePermissionsEdit[roleHash] = 2
                    this.sliderEditChange(roleHash, 2)
                  } else if (!fieldData.permissions[roleHash].can_edit && fieldData.permissions[roleHash].visible) {
                    this.rolePermissionsEdit[roleHash] = 1
                    this.sliderEditChange(roleHash, 1)
                  } else {
                    this.rolePermissionsEdit[roleHash] = 0
                    this.sliderEditChange(roleHash, 0)
                  }
                })
              }, 300)

              this.editFieldPopUpActive = true

              this.$vs.loading.close()

            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          throw new Error(e.message)
        })
    },
    deleteBlockConfirm (elementHash) {
      const block = document.querySelector(`#block-${  elementHash}`)

      const fields = block.querySelector('.vx-card').querySelector('.vx-card__collapsible-content.vs-con-loading__container').querySelector('.vx-card__body').children[0].children

      if (fields.length > 0) {
        this.$vs.notify({
          title: 'Atenção',
          text: 'O Bloco contém Campos, mova os campos ou exclua-os antes de prosseguir',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })


      } else if (this.unsavedLayout) {
        this.$vs.notify({
          title: 'Atenção',
          text: 'Salve as alterações de layout antes de excluir o bloco',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })


      } else {

        this.currentBlockToDelete = elementHash

        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Confirmar Exclusão',
          text: 'Você tem certeza que excluir deletar este bloco?',
          accept: this.deleteBlock,
          acceptText: 'Excluir'
        })
      }
    },
    async deleteBlock () {
      this.$vs.loading({type: 'default'})

      // fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'module_management_delete_application_module_block',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       module_token: this.$route.params.moduleHash,
      //       block_token: this.currentBlockToDelete
      //     }
      //   })
      // })
      await performFetch(`${this.$store.state.auth.api_url}`, {
          command: 'module_management_delete_application_module_block',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            module_token: this.$route.params.moduleHash,
            block_token: this.currentBlockToDelete
          }
        })
        .then(async (response) => {
          this.$vs.loading.close()
          if (response.status === 200) {
            response.json().then(async (responseData) => {

              this.currentBlockToDelete = ''

              this.$vs.loading.close()

              await this.loadData()

              this.$vs.notify({
                title: 'Operação realizada!',
                text: 'Bloco excluído com sucesso!',
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
              })

            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          throw new Error(e.message)
        })
    },
    deleteFieldConfirm (elementHash) {

      this.currentFieldToDelete = elementHash

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmar Exclusão',
        text: 'Você tem certeza que excluir deletar este campo?',
        accept: this.deleteField,
        acceptText: 'Excluir'
      })
    },
    async deleteField () {

      this.$vs.loading({type: 'default'})

      // fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'module_management_delete_application_module_field',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       module_token: this.$route.params.moduleHash,
      //       field_token: this.currentFieldToDelete
      //     }
      //   })
      // })
      await performFetch(`${this.$store.state.auth.api_url}`, {
          command: 'module_management_delete_application_module_field',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            module_token: this.$route.params.moduleHash,
            field_token: this.currentFieldToDelete
          }
        })
        .then(async (response) => {
          this.$vs.loading.close()
          if (response.status === 200) {
            response.json().then(async (responseData) => {

              this.currentFieldToDelete = ''

              this.$vs.loading.close()

              await this.loadData()

              this.$vs.notify({
                title: 'Operação realizada!',
                text: 'Campo excluído com sucesso!',
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
              })

            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Operação não realizada!',
              text: 'Ocorreu um erro ao excluir o campo!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Operação não realizada!',
            text: 'Ocorreu um erro ao excluir o campo!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })

    },
    resetNewFieldForm () {
      this.fieldData.name = ''
      this.fieldData.subtitle = null
      this.fieldData.placeholder = null
      this.fieldData.defaultValue = null
      this.fieldData.showHint = false
      this.fieldData.decimals = 2
      this.fieldData.hint = null
      this.fieldData.length = null
      this.fieldData.columnsOnForm = 1
      this.fieldData.minValue = null
      this.fieldData.maxValue = null
      this.fieldData.minValueInt = null
      this.fieldData.maxValueInt = null
      this.fieldData.minValueDate = null
      this.fieldData.maxValueDate = null
      this.fieldData.minValueDateTime = null
      this.fieldData.maxValueDateTime = null
      this.fieldData.mask = null
      this.fieldData.quickCreate = false
      this.fieldData.massEdit = false
      this.fieldData.showIcon = false
      this.fieldData.mandatory = false
      this.fieldData.entireLine = false
      this.fieldData.relatedTab = false
      this.fieldData.unique = false
      this.fieldData.secret = false
      this.fieldData.showProgressBar = false
      this.fieldData.moduleOptions = []
      this.fieldData.moduleFieldOptions = []
      this.fieldData.relatedModule = {}
      this.fieldData.relatedField = {}
      this.fieldData.secret = false
      this.fieldData.type = {id: 0, name: ''}
      this.fieldData.options = []
    },
    resetEditFieldForm () {
      this.fieldEditData.options = []
      this.fieldEditData.relatedTab = false
      this.fieldEditData.moduleOptions = []
      this.fieldEditData.moduleFieldOptions = []
      this.fieldEditData.showProgressBar = false
      this.fieldEditData.relatedModule = {}
      this.fieldEditData.relatedField = {}
      this.fieldEditData.disableAll = true
      this.fieldEditData.type ={id: 0, name: ''}
      this.fieldEditData.name = ''
      this.fieldEditData.subtitle = null
      this.fieldEditData.placeholder = null
      this.fieldEditData.defaultValue = null
      this.fieldEditData.showHint = false
      this.fieldEditData.decimals = 2
      this.fieldEditData.hint = null
      this.fieldEditData.length = null
      this.fieldEditData.mask = null
      this.fieldEditData.columnsOnForm = 1
      this.fieldEditData.minValue = null
      this.fieldEditData.maxValue = null
      this.fieldEditData.minValueInt = null
      this.fieldEditData.maxValueInt = null
      this.fieldEditData.minValueDate = null
      this.fieldEditData.maxValueDate = null
      this.fieldEditData.minValueDateTime = null
      this.fieldEditData.maxValueDateTime = null
      this.fieldEditData.quickCreate = false
      this.fieldEditData.massEdit = false
      this.fieldEditData.showIcon = false
      this.fieldEditData.mandatory = false
      this.fieldEditData.entireLine = false
      this.fieldEditData.unique = false
      this.fieldEditData.secret = false
    },
    async editFormSubmitted () {

      this.$vs.loading({type: 'default'})

      const permissionObject = {}

      Object.keys(this.rolePermissionsEdit).forEach((item) => {

        if (this.rolePermissionsEdit[item] === 2) {
          permissionObject[item] = {
            visible: true,
            can_edit: true
          }
        } else if (this.rolePermissionsEdit[item] === 1) {
          permissionObject[item] = {
            visible: true,
            can_edit: false
          }
        } else {
          permissionObject[item] = {
            visible: false,
            can_edit: false
          }
        }
      })

      const fieldBody = {
        hash: this.fieldEditData.hash,
        name: this.fieldEditData.name,
        subtitle: this.fieldEditData.subtitle,
        type_id: this.fieldEditData.type.id,
        columns_on_form: this.fieldEditData.columnsOnForm,
        show_hint: this.fieldEditData.showHint,
        hint: this.fieldEditData.hint,
        placeholder: this.fieldEditData.placeholder,
        min_value: this.fieldEditData.minValue,
        max_value: this.fieldEditData.maxValue,
        default_value: this.fieldEditData.defaultValue,
        decimals: this.fieldEditData.decimals,
        mask: this.fieldEditData.mask,
        length: this.fieldEditData.length,
        quick_create: this.fieldEditData.quickCreate,
        mass_edit: this.fieldEditData.massEdit,
        show_icon: this.fieldEditData.showIcon,
        mandatory: this.fieldEditData.mandatory,
        entire_line: this.fieldEditData.entireLine,
        secret: this.fieldEditData.secret,
        unique: this.fieldEditData.unique,
        show_progress_bar: this.fieldEditData.showProgressBar,
        permissions: permissionObject,
        related_module_hash: Object.keys(this.fieldEditData.relatedModule).length === 0 && this.fieldEditData.relatedModule.constructor === Object ? null : this.fieldEditData.relatedModule.hash,
        related_module_field_hash: Object.keys(this.fieldEditData.relatedField).length === 0 && this.fieldEditData.relatedField.constructor === Object ? null : this.fieldEditData.relatedField.hash,
        has_related_tab: this.fieldEditData.relatedTab,
        options: this.fieldEditData.options,
        dependent_field: this.fieldEditData.dependentField !== null ? this.fieldEditData.dependentField.hash : null
      }

      // fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'module_management_update_application_module_field',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       module_token: this.$route.params.moduleHash,
      //       field: fieldBody
      //     }
      //   })
      // })
      await performFetch(`${this.$store.state.auth.api_url}`, {
          command: 'module_management_update_application_module_field',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            module_token: this.$route.params.moduleHash,
            field: fieldBody
          }
        })
        .then(async (response) => {
          this.$vs.loading.close()
          if (response.status === 200) {

            this.$vs.loading.close()

            this.editFieldPopUpActive = false

            await this.loadData()

            this.$vs.notify({
              title: 'Operação realizada!',
              text: 'Campo atualizado com sucesso!',
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else if(response.status === 400) {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Atenção!',
              text: 'Já existe um campo com este nome!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })
            this.showEmptyDataMessage = !this.showEmptyDataMessage
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.showEmptyDataMessage = !this.showEmptyDataMessage
          this.$vs.notify({
            title: 'Operação não realizada!',
            text: 'Ocorreu um erro ao atualizar o campo!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })

    },
    async addFormSubmitted () {

      this.$vs.loading({type: 'default'})

      const permissionObject = {}

      Object.keys(this.rolePermissions).forEach((item) => {
        if (this.rolePermissions[item] === 2) {
          permissionObject[item] = {
            visible: true,
            can_edit: true
          }
        } else if (this.rolePermissions[item] === 1) {
          permissionObject[item] = {
            visible: true,
            can_edit: false
          }
        } else {
          permissionObject[item] = {
            visible: false,
            can_edit: false
          }
        }
      })

      const fieldBody = {
        name: this.fieldData.name,
        subtitle: this.fieldData.subtitle,
        type_id: this.fieldData.type.id,
        columns_on_form: this.fieldData.columnsOnForm,
        show_hint: this.fieldData.showHint,
        hint: this.fieldData.hint,
        placeholder: this.fieldData.placeholder,
        min_value: this.fieldData.minValue,
        max_value: this.fieldData.maxValue,
        default_value: this.fieldData.defaultValue,
        decimals: this.fieldData.decimals,
        mask: this.fieldData.mask,
        length: this.fieldData.length,
        quick_create: this.fieldData.quickCreate,
        mass_edit: this.fieldData.massEdit,
        show_icon: this.fieldData.showIcon,
        mandatory: this.fieldData.mandatory,
        entire_line: this.fieldData.entireLine,
        secret: this.fieldData.secret,
        permissions: permissionObject,
        unique: this.fieldData.unique,
        show_progress_bar: this.fieldData.showProgressBar,
        related_module_hash: Object.keys(this.fieldData.relatedModule).length === 0 && this.fieldData.relatedModule.constructor === Object ? null : this.fieldData.relatedModule.hash,
        related_module_field_hash: Object.keys(this.fieldData.relatedField).length === 0 && this.fieldData.relatedField.constructor === Object ? null : this.fieldData.relatedField.hash,
        has_related_tab: this.fieldData.relatedTab,
        options: this.fieldData.options,
        dependent_field: this.fieldData.dependentField !== null ? this.fieldData.dependentField.hash : null
      }

      // fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'module_management_add_application_module_field',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       module_token: this.$route.params.moduleHash,
      //       block_token: this.currentBlockToAddField,
      //       field: fieldBody
      //     }
      //   })
      // })
      await performFetch(`${this.$store.state.auth.api_url}`, {
          command: 'module_management_add_application_module_field',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            module_token: this.$route.params.moduleHash,
            block_token: this.currentBlockToAddField,
            field: fieldBody
          }
        })
        .then(async (response) => {
          this.$vs.loading.close()
          if (response.status === 200) {

            this.addFieldPopUpActive = false
            this.currentBlockToAddField = ''

            this.resetNewFieldForm()

            this.$vs.loading.close()

            await this.loadData()

            this.$vs.notify({
              title: 'Operação realizada!',
              text: 'Campo adicionado com sucesso!',
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else if(response.status === 400){
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Atenção!',
              text: 'Já existe um campo com este nome!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Operação não realizada!',
            text: 'Ocorreu um erro ao atualizar o campo!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    addButtonClicked (elementHash) {
      this.addFieldPopUpActive = true
      document.querySelectorAll('.wizard-nav.wizard-nav-pills')[1].querySelectorAll('li')[0].click()
      this.currentBlockToAddField = elementHash
    },
    async loadData () {
      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'module_management_get_application_module_fields',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       module_token: this.$route.params.moduleHash
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
          command: 'module_management_get_application_module_fields',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            module_token: this.$route.params.moduleHash
          }
        })
        .then(async (response) => {
          this.$vs.loading.close()
          if (response.status === 200) {
            response.json().then(async (responseData) => {

              this.moduleInfo['name'] = responseData.module.name

              if (responseData.module.payload.length > 0) {

                this.blockData = responseData.module.payload

                this.blockData.sort((a, b) => {

                  if (a.index < b.index) return -1
                  if (a.index < b.index) return 1
                  return 0

                })

                this.blockData.map((item, key) => {

                  this.$set(this.blockObject, item.hash, {
                    collapsed: item.collapsed,
                    visible: item.visible,
                    title: item.title,
                    hash: item.hash,
                    roles: Array.isArray(item.roles) ? item.roles : []
                  })

                  item.fields = item.fields.filter(x => ((x.name === 'assigned_to_id' || x.name === 'event_name' || x.name === 'start_date' || x.name === 'end_date') || x.core === false))

                  item.fields.map(fieldItem => {
                    fieldItem.columns_on_form = 4

                    return fieldItem
                  })

                  item.fields.sort((a, b) => {

                    if (a.index < b.index) return -1
                    if (a.index < b.index) return 1
                    return 0

                  })
                })
              }
            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          throw new Error(e.message)
        })

      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'module_management_add_application_module_field_parameters',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
          command: 'module_management_add_application_module_field_parameters',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token
          }
        })
        .then(async (response) => {
          this.$vs.loading.close()
          if (response.status === 200) {
            response.json().then(async (responseData) => {

              this.fieldData.typeOptions = responseData.parameters.field_types

              this.fieldData.typeOptions = this.fieldData.typeOptions.filter(x => x.id === 1 || x.id === 8 || x.id === 12 || x.id === 13 || x.id === 17 || x.id === 19 || x.id === 24 || x.id === 25)

              this.roleList = responseData.parameters.roles

              const data = []

              let i, j, temparray, chunk = 3

              for (i = 0, j = this.roleList.length; i < j; i += chunk) {
                temparray = this.roleList.slice(i, i + chunk)

                data.push(temparray)
              }

              this.roleListSliced = data

              responseData.parameters.roles.forEach((item) => {
                this.$set(this.rolePermissions, item.hash, 2)
                this.$set(this.rolePermissionsEdit, item.hash, 2)
                setTimeout(() => {
                  this.sliderChange(item.hash, 2)
                }, 300)
              })
            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          throw new Error(e.message)
        })
    },
    dropItem (event) {

      this.unsavedLayout = true
    },
    dragStart (event) {
      // console.log(event)
    },
    fieldColumn (columnsOnForm) {

      if (this.max_columns === 1) {
        return 'vx-col w-full'
      } else if (this.max_columns === 2) {
        if (columnsOnForm === 1) {
          return 'vx-col w-full md:w-1/2'
        } else {
          return 'vx-col w-full'
        }
      } else if (this.max_columns === 3) {
        if (columnsOnForm === 1) {
          return 'vx-col w-full md:w-1/3'
        } else if (columnsOnForm === 2) {
          return 'vx-col w-full md:w-2/3'
        } else {
          return 'vx-col w-full'
        }
      } else if (columnsOnForm === 1) {
        return 'vx-col w-full md:w-1/4'
      } else if (columnsOnForm === 2) {
        return 'vx-col w-full md:w-1/2'
      } else if (columnsOnForm === 3) {
        return 'vx-col w-full md:w-3/4'
      } else {
        return 'vx-col w-full'
      }
    }
  },
  mounted () {

    document.title = `${document.title.split(' | ')[0]  } | Campos`

    document.querySelectorAll('.vx-card__body')[0].style.padding = '0.75rem'

  },
  async created () {
    this.$vs.loading({
      type: 'default'
    })

    await this.loadData()
  }
}

</script>

<style lang="scss" scoped>
.vx-row {
  transition: all 1s;
}

.field-type-select >>> .vs__dropdown-menu {
  height: 168px !important;
}

.vs-con-table >>> .vs-con-tbody {
  background: #ffffff!important;
}

.vs-slider--circles.isEndValue {
  border-radius: 50%!important;
}

.con-vs-popup >>> .vs-popup {
  // width: 1000px!important;
  width: 1000px!important;
  height: auto!important;
}
</style>
